import { MerchantId, SetHeaderService } from "@/helper/authenticationHelper";
import { DocumentIdModel, DocumentUpdateOnlineViewPassCodeModel } from "@/model/document/documentModel";
import {
  SettingContactEnvelopeDocumentTemplateModel,
  SettingDocumentTemplateModel,
  SettingExecutiveSummaryDocumentTemplateModel,
  SettingJournalDocumentTemplateModel,
  SettingPP30DocumentTemplateModel,
  SettingPndDocumentTemplateModel,
  SettingWitholdingTaxDocumentTemplateModel,
} from "@/model/document/settingDocumentTemplate";
import service from "../baseHttpService";
import {
  PrepareOnlineViewPassCodeDocumentInputData,
  PrepareOnlineViewTemplateDocumentInputData,
  PrepareOnlineViewTemplateMainDocumentInputData,
} from "./documentFacade";

class DocumentService {
  DoRemoveOnlineViewPassCode(input: DocumentUpdateOnlineViewPassCodeModel) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareOnlineViewPassCodeDocumentInputData(input),
    };
    return service.peakOnlineView
      .post("/api/OnlineView/RemoveOnlineViewPassCode", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateOnlineViewPassCode(input: DocumentUpdateOnlineViewPassCodeModel) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareOnlineViewPassCodeDocumentInputData(input),
    };
    return service.peakOnlineView
      .post("/api/OnlineView/UpdateOnlineViewPassCode", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateTemplateDetailDocument(
    settingDocumentTemplate:
      | SettingDocumentTemplateModel
      | SettingJournalDocumentTemplateModel
      | SettingWitholdingTaxDocumentTemplateModel
      | SettingPP30DocumentTemplateModel
      | SettingPndDocumentTemplateModel
      | SettingContactEnvelopeDocumentTemplateModel
      | SettingExecutiveSummaryDocumentTemplateModel,
    documentId: DocumentIdModel,
    headerOptionType: Number
  ) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareOnlineViewTemplateDocumentInputData(settingDocumentTemplate, documentId, headerOptionType),
    };
    return service.peakOnlineView
      .post("/api/OnlineView/UpdateTemplateDetail", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateTemplateMainDetailDocument(
    settingDocumentTemplate:
      | SettingDocumentTemplateModel
      | SettingJournalDocumentTemplateModel
      | SettingWitholdingTaxDocumentTemplateModel
      | SettingPP30DocumentTemplateModel
      | SettingPndDocumentTemplateModel
      | SettingContactEnvelopeDocumentTemplateModel
      | SettingExecutiveSummaryDocumentTemplateModel,
    documentId: DocumentIdModel,
    headerOptionType: Number
  ) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareOnlineViewTemplateMainDocumentInputData(settingDocumentTemplate, documentId, headerOptionType),
    };
    return service.peakOnlineView
      .post("/api/OnlineView/UpdateTemplateMainDetail", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateTemplateMainExecutiveSummaryDocument(
    settingDocumentTemplate: SettingExecutiveSummaryDocumentTemplateModel,
    documentId: DocumentIdModel,
    headerOptionType: Number
  ) {
    const _input = {
      merchantId: MerchantId(),
      transactionType: documentId.transactionType,
      financeType: documentId.financeType,
      headerOptionType: headerOptionType,
      template: settingDocumentTemplate,
      sourceType: documentId.sourceType,
    };
    return service.peakRealTimeAPI
      .post("/api/OnlineView/UpdateTemplateExecutiveSummaryMainDetail", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new DocumentService();
